import { ENVIRONMENTS, IWebEnvironment } from '@shared/interfaces';

/* eslint-disable @typescript-eslint/no-var-requires */
export const environment: IWebEnvironment = {
  env: ENVIRONMENTS.LOCAL,
  production: true,
  isDebugMode: true,
  isSentryDebugMode: false,
  VERSION: require('../../../../package.json').version,
  CORE_VERSION: require('../../../../package.json').coreversion,
  API_URL: 'https://uat.foms.ainsunhz.com',
  WEB_URL: 'https://uat.foms.ainsunhz.com',
  WEB_DOMAIN: 'uat.foms.ainsunhz.com',
  API_DOMAIN: 'uat.foms.ainsunhz.com',
  SENTRY_DSN: process.env.NX_WEB_SENTRY_DSN,
};
